<template>
    <div class="row">
         <div class="col-md-12">
            <div class="form-group">
                <Dropdown  ref="buscadorclientes2" showClear editable :options="clientes" v-model="clienteseleccionado"  filter
                        optionLabel="nombre" placeholder="Búsqueda Clientes (Tlf, dirección, nombre, NIF, email)"
                        @keyup.enter="cargarclientes()" style="width:100%">
                        
                </Dropdown>            
            </div>
        </div>
         
        <div class="col-md-10">
            <div class="form-group">
                <label>{{ $t('general.nombre') }}</label>
                <input type="text" @input="modificado['nombre']=1" v-model="clienteasegurado.nombre" class="form-control input-sm">
            </div>
        </div>
        <div class="col-md-2">
            <div class="form-group">
                <label>VIP</label>
                <p><input @input="modificado['vip']=1"
                type="checkbox"
                v-model="clienteasegurado.vip_cliente"
                :true-value="'SI'"
                :false-value="''"
                /></p>
            </div>
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <label>{{ $t('general.razonsocial') }}</label>
                <input type="text" @input="modificado['razonsocial']=1" v-model="clienteasegurado.razon_social" class="form-control input-sm" readonly>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label>Tipo de Identificación</label>
                <select @change="modificado['tipoidentificacion']=1;modificado['nif']=1" v-model="clienteasegurado.tipo_identificacion" class="form-control">
                        <option value="">----</option>
                        <option value="N.I.F.">N.I.F.</option>
                        <option value="C.I.F.">C.I.F.</option>
                        <option value="N.I.E.">N.I.E.</option>
                        <option value="OTROS">{{ $t('general.otros') }}</option>
                </select>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label>Nº de Identificación</label>
                <input type="text" @input="modificado['nif']=1;modificado['tipoidentificacion']=1" v-model="clienteasegurado.nif" class="form-control input-sm">
            </div>
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <label>{{ $t('general.direccion') }}</label>
                <input type="text" @input="modificado['direccion']=1" v-model="clienteasegurado.direccion" class="form-control input-sm">
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label>{{ $t('general.poblacion') }}</label>
                <input type="text" @input="modificado['poblacion']=1" v-model="clienteasegurado.poblacion" class="form-control input-sm">
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label>{{ $t('general.cpostal') }}</label>
                <input type="text" @input="modificado['cpostal']=1" v-model="clienteasegurado.codigo_postal" class="form-control input-sm">
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label>{{ $t('general.provincia') }}</label>
                <input type="text" @input="modificado['provincia']=1" v-model="clienteasegurado.provincia" class="form-control input-sm">
            </div>
        </div>
        <div class="col-md-4">

            <div class="form-group">
                <label>{{ $t('general.telefono') }} 1</label>
                <div class="input-group">
                    <input type="text" @input="modificado['telefono']=1" v-model="clienteasegurado.telefono1" class="form-control input-sm">
                    <div class="input-group-append">
                        <span class="input-group-text" title="¿Es Móvil?">
                            <input type="checkbox" name="telefono1_movil" v-model="clienteasegurado.telefono1_movil"
                                v-bind:true-value="1" v-bind:false-value="0">
                        </span>
                    </div>
                </div>
                <textarea class="form-control input-sm" @input="modificado['descrtelefono']=1" v-model="clienteasegurado.telefono1_descripcion"
                    :placeholder="$t('general.descripcion')"></textarea>
                <div class="row" style="justify-content: center; column-gap: 2em;">
                    <label for="radio1" style="margin: 0;">Preferente</label>
                    <input id="radio1" value="1" v-model="preferente" type="radio">
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label>{{ $t('general.telefono') }} 2</label>
                <div class="input-group">
                    <input type="text" @input="modificado['telefono2']=1" v-model="clienteasegurado.telefono2" class="form-control input-sm">
                    <div class="input-group-append" title="¿Es Móvil?">
                        <span class="input-group-text">
                            <input type="checkbox" v-model="clienteasegurado.telefono2_movil" v-bind:true-value="1"
                                v-bind:false-value="0">
                        </span>
                    </div>
                </div>
                <textarea class="form-control input-sm"  @input="modificado['descrtelefono2']=1" v-model="clienteasegurado.telefono2_descripcion"
                    :placeholder="$t('general.descripcion')"></textarea>
                <div class="row" style="justify-content: center; column-gap: 2em;">
                    <label for="radio2" style="margin: 0;">Preferente</label>
                    <input id="radio2" value="2" v-model="preferente" type="radio">
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label>{{ $t('general.telefono') }} 3</label>
                <div class="input-group">
                    <input type="text" @input="modificado['telefono3']=1" v-model="clienteasegurado.telefono3" class="form-control input-sm">
                    <div class="input-group-append" title="¿Es Móvil?">
                        <span class="input-group-text">
                            <input type="checkbox" v-model="clienteasegurado.telefono3_movil" v-bind:true-value="1" v-bind:false-value="0">
                        </span>
                    </div>
                </div>
                <textarea class="form-control input-sm" @input="modificado['descrtelefono3']=1" v-model="clienteasegurado.telefono3_descripcion"
                    :placeholder="$t('general.descripcion')"></textarea>
                <div class="row" style="justify-content: center; column-gap: 2em;">
                    <label for="radio3" style="margin: 0;">Preferente</label>
                    <input id="radio3" value="3" v-model="preferente" type="radio">
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <label>Email</label>
                <input type="text" @input="modificado['email']=1" v-model="clienteasegurado.email" class="form-control input-sm">
            </div>
        </div>
        <div class="col-md-12">
            <label>IBAN ***</label>
            <div class="input-group mb-3">
                <input type="text" @input="modificado['iban']=1" class="form-control form-control-sm" style="width:20px" v-model="numero_iban1"
                    maxlength="4">
                <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                <input type="text" @input="modificado['iban']=1" class="form-control form-control-sm" v-model="numero_iban2" maxlength="4">
                <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                <input type="text" @input="modificado['iban']=1" class="form-control form-control-sm" v-model="numero_entidad" maxlength="4">
                <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                <input type="text" @input="modificado['iban']=1" class="form-control form-control-sm" v-model="numero_oficina" maxlength="4">
                <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                <input type="text" @input="modificado['iban']=1" class="form-control form-control-sm" v-model="numero_dc" maxlength="4">
                <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                <input type="text" @input="modificado['iban']=1" class="form-control form-control-sm" v-model="numero_cuenta" maxlength="4">
            </div>
        </div>

        <div class="col-md-6">
            <div class="form-group">
                <label>{{ $t('general.poliza') }}</label>
                <input type="text" @input="modificado['poliza']=1" v-model="clienteasegurado.poliza" class="form-control input-sm">
            </div>
        </div>
        <div class="col-md-6" v-if="permisosusuario.includes('soporte')">
            <div class="form-group">
                <label>{{ $t('general.subcuenta') }}</label>
                <br>
                <input disabled type="text" v-model="clienteasegurado.contador_subcuenta" class="form-control input-sm">
            </div>  
        </div>
        <div class="col-md-6" v-else>
            <div class="form-group">
                <label>{{ $t('general.subcuenta') }}</label>
                <br>
                <label>{{ clienteasegurado.contador_subcuenta }}</label>
            </div>
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <label>{{ $t('general.companyia') }}</label>
                <input type="text" @input="modificado['compania']=1" v-model="clienteasegurado.nombre_compania" class="form-control input-sm">
            </div>
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <label>{{ $t('general.observaciones') }}</label>
                <textarea  v-model="clienteasegurado.observaciones" @input="modificado['observaciones']=1" class="form-control"></textarea>
            </div>
        </div>
    </div>
</template>
<script>
import { PwgsApi } from '../../../../../services/PwgsApi';
import Dropdown from 'primevue/dropdown';
export default ({
    props: ['id', 'servicio', 'asegurado','guardaraseguradotoken'],

    setup() {
    },
    data() {
        return {
            modificado:[],
            preferente:0,
            clienteasegurado: [],
            clientes: '',
            aux: '',
            buscador: [],
            auxbuscador: '',
            ids: [],
            idcliente: '',
            numero_iban1:'',
            numero_iban2: '',
            numero_cuenta: '',
            numero_entidad: '',
            numero_oficina: '',
            numero_dc:'',
            permisosusuario: [],
            clienteseleccionado:'',
        }
    },
    mounted() {
        //this.clienteasegurado = this.$props.asegurado;
        this.idcliente = this.$props.asegurado.idcliente;
        this.cargarasegurado();
        this.comprobarPreferente();
        this.comprobarpermisos();
    },
    methods: {
        comprobarPreferente(){
            if(this.asegurado.telefono_prioritario!=0) {
                this.preferente = this.asegurado.telefono_prioritario;
            }    
        },
     
          async cargarclientes() {
            //POST   modulos/pwgsapi/index.php/clientes/busqueda
            this.clientes = '';
            const api = new PwgsApi();
            let subidadatos = { buscador: this.$refs.buscadorclientes2.modelValue }
            let aux = '';
            aux = await api.post('clientes/busqueda', subidadatos);
            this.clientes = aux.datos
            
            this.$refs.buscadorclientes2.show();
        },
        buscarcliente() {
            this.buscador.length = 0;
            if (this.auxbuscador.length < 3) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Debe introducir al menos 3 caracteres para buscar un cliente', life: 5000 });

            }
            else {
                console.log("clientes", this.clientes);
                console.log("auxbuscador", this.auxbuscador);
                for (let i = 0; i < this.clientes.length; i++) {
                    if (this.clientes[i].nombre.includes(this.auxbuscador)) {
                        this.buscador.push(this.clientes[i].nombre);
                        this.ids.push(this.clientes[i].idcliente);
                    }
                }
            }
        },
        async cargarasegurado() { 
        //GET  modulos/pwgsapi/index.php/clientcl
            for (let i = 0; i < this.buscador.length; i++){
                if (this.aux == this.buscador[i]) { 
                    this.idcliente = this.ids[i];
                }
            }
            const api = new PwgsApi;
            const datos = await api.get('clientes/' + this.idcliente);
            this.clienteasegurado = datos.datos;
            console.log('this.clienteasegurado', this.clienteasegurado);
            this.numero_iban1 = this.clienteasegurado.numero_iban1;
            this.numero_iban2 = this.clienteasegurado.numero_iban2;
            this.numero_cuenta = this.clienteasegurado.numero_cuenta;
            this.numero_entidad = this.clienteasegurado.numero_entidad;
            this.numero_oficina = this.clienteasegurado.numero_oficina;
            this.numero_dc = this.clienteasegurado.numero_dc;
            const digitosSubcuentas = this.clienteasegurado.numRegistros;
            const resultado = '43' + String(this.clienteasegurado.contador_subcuenta).padStart(digitosSubcuentas - 2, '0');
            console.log('resultado', resultado);
            this.clienteasegurado.contador_subcuenta = resultado;

        },
        async guardarasegurado() { 
            //PUT /clientes/:id/modificar-cliente-servicio/:id_servicio

           if (this.clienteasegurado.telefono1) {
            let tel = String(this.clienteasegurado.telefono1);
            // Rechazar solo si hay letras reales; cualquier otra cosa (invisibles, espacios, guiones) se descarta
            if (/[a-zA-ZñÑ]/.test(tel)) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'El teléfono solo puede contener números', life: 5000 });
                return;
            }
            tel = tel.replace(/\D/g, '');
            this.clienteasegurado.telefono1 = tel;
            if (tel.length < 9) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'El teléfono debe contener al menos 9 dígitos', life: 5000 });
                return;
            }
            }
           if (this.clienteasegurado.telefono2) {
            let tel2 = String(this.clienteasegurado.telefono2);
            // Rechazar solo si hay letras reales; cualquier otra cosa (invisibles, espacios, guiones) se descarta
            if (/[a-zA-ZñÑ]/.test(tel2)) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'El teléfono solo puede contener números', life: 5000 });
                return;
            }
            tel2 = tel2.replace(/\D/g, '');
            this.clienteasegurado.telefono2 = tel2;
           if (tel2.length < 9) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'El teléfono debe contener al menos 9 dígitos', life: 5000 });
                return;
            }
            }
           if (this.clienteasegurado.telefono3) {
            let tel3 = String(this.clienteasegurado.telefono3);
            // Rechazar solo si hay letras reales; cualquier otra cosa (invisibles, espacios, guiones) se descarta
            if (/[a-zA-ZñÑ]/.test(tel3)) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'El teléfono solo puede contener números', life: 5000 });
                return;
            }
            tel3 = tel3.replace(/\D/g, '');
            this.clienteasegurado.telefono3 = tel3;
            if (tel3.length < 9) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'El teléfono debe contener al menos 9 dígitos', life: 5000 });
                return;
            }
            }
             /* provincia: this.clienteasegurado.provincia, 
                poblacion: this.clienteasegurado.poblacion, 
                nombre: this.clienteasegurado.nombre, 
                razon_social: this.clienteasegurado.razon_social, 
                nif: this.clienteasegurado.nif, 
                telefono1: this.clienteasegurado.telefono1, 
                telefono2: this.clienteasegurado.telefono2, 
                telefono3: this.clienteasegurado.telefono3,
                telefono1_movil:this.clienteasegurado.telefono1_movil,
                telefono2_movil:this.clienteasegurado.telefono2_movil,
                telefono3_movil:this.clienteasegurado.telefono3_movil,
                email: this.clienteasegurado.email,
                direccion: this.clienteasegurado.direccion, 
                codigo_postal: this.clienteasegurado.codigo_postal, 
                telefono1_descripcion: this.clienteasegurado.telefono1_descripcion,
                telefono2_descripcion: this.clienteasegurado.telefono2_descripcion,
                telefono3_descripcion: this.clienteasegurado.telefono3_descripcion,
                numero_iban1: this.numero_iban1,
                numero_iban2: this.numero_iban2,
                numero_cuenta: this.numero_cuenta,
                numero_entidad: this.numero_entidad,
                numero_oficina: this.numero_oficina,
                numero_dc: this.numero_dc,
                observaciones: this.clienteasegurado.observaciones,
                poliza: this.clienteasegurado.poliza,
                nombre_compania: this.clienteasegurado.nombre_compania,
                vip_cliente: this.clienteasegurado.vip_cliente,*/
            let datossubida = {};

        if(this.modificado['provincia']==1){datossubida.provincia = this.clienteasegurado.provincia;}
        if(this.modificado['poblacion']==1){datossubida.poblacion = this.clienteasegurado.poblacion;}
        if(this.modificado['nombre']==1){datossubida.nombre = this.clienteasegurado.nombre;}
        if(this.modificado['razonsocial']==1){datossubida.razon_social = this.clienteasegurado.razon_social;}
        if(this.modificado['nif']==1){datossubida.nif = this.clienteasegurado.nif;}
        if(this.modificado['tipoidentificacion']==1){datossubida.tipo_identificacion = this.clienteasegurado.tipo_identificacion;}
        if(this.modificado['telefono']==1){datossubida.telefono1 = this.clienteasegurado.telefono1;}
        if(this.modificado['telefono2']==1){datossubida.telefono2 = this.clienteasegurado.telefono2;}
        if(this.modificado['telefono3']==1){datossubida.telefono3 = this.clienteasegurado.telefono3;}
        if(this.modificado['telefono']==1){datossubida.telefono1_movil = this.clienteasegurado.telefono1_movil;}
        if(this.modificado['telefono2']==1){datossubida.telefono2_movil = this.clienteasegurado.telefono2_movil;}
        if(this.modificado['telefono3']==1){datossubida.telefono3_movil = this.clienteasegurado.telefono3_movil;}
        if(this.modificado['email']==1){datossubida.email = this.clienteasegurado.email;}
        if(this.modificado['direccion']==1){datossubida.direccion = this.clienteasegurado.direccion;}
        if(this.modificado['cpostal']==1){datossubida.codigo_postal = this.clienteasegurado.codigo_postal;}
        if(this.modificado['descrtelefono']==1){datossubida.telefono1_descripcion = this.clienteasegurado.telefono1_descripcion;}
        if(this.modificado['descrtelefono2']==1){datossubida.telefono2_descripcion = this.clienteasegurado.telefono2_descripcion;}
        if(this.modificado['descrtelefono3']==1){datossubida.telefono3_descripcion = this.clienteasegurado.telefono3_descripcion;}
        if(this.modificado['iban']==1){datossubida.numero_iban1 = this.numero_iban1;}
        if(this.modificado['iban']==1){datossubida.numero_iban2 = this.numero_iban2;}
        if(this.modificado['iban']==1){datossubida.numero_cuenta = this.numero_cuenta;}
        if(this.modificado['iban']==1){datossubida.numero_entidad = this.numero_entidad;}
        if(this.modificado['iban']==1){datossubida.numero_oficina = this.numero_oficina;}
        if(this.modificado['iban']==1){datossubida.numero_dc = this.numero_dc;}
        if(this.modificado['observaciones']==1){datossubida.observaciones = this.clienteasegurado.observaciones;}
        if(this.modificado['poliza']==1){datossubida.poliza = this.clienteasegurado.poliza;}
        if(this.modificado['compania']==1){datossubida.nombre_compania = this.clienteasegurado.nombre_compania;}
        if(this.modificado['vip']==1){datossubida.vip_cliente = this.clienteasegurado.vip_cliente;}

            if(this.preferente!=0){                    
                datossubida.telefono_prioritario = this.preferente; 
            }
            try {
                const api = new PwgsApi;
                await api.put('clientes/' + this.idcliente + '/modificar-cliente-servicio/' +this.$props.id, datossubida);

                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                this.$emit('actualizarasegurado');
                this.$parent.$parent.$parent.cargardatos(this.$props.id,"cual","si");
                this.$parent.$parent.$parent.cargarmasdatos(this.$props.id, "cual", "si");
                this.modificado = [];
                this.$emit('ver');
            }
            catch (error) {
                const mensajeError = error.toString();

                if (mensajeError.includes('Este cliente ya existe')) {
                    const aceptaUsarDatos = confirm(mensajeError);

                    if (aceptaUsarDatos) {
                        const datosReintento = { 
                            ...datossubida, 
                            confirmar_asignacion_cliente: true 
                        };
                        try {
                            const api = new PwgsApi;
                            await api.put('clientes/' + this.idcliente + '/modificar-cliente-servicio/' + this.$props.id, datosReintento);
                            
                            this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                            this.$emit('actualizarasegurado');
                            this.$parent.$parent.$parent.cargardatos(this.$props.id, "cual", "si");
                            this.$parent.$parent.$parent.cargarmasdatos(this.$props.id, "cual", "si");
                            this.modificado = [];
                            this.$emit('ver');
                        } catch (reError) {
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar la confirmación', life: 5000 });
                        }
                         this.$emit('actualizarasegurado');
                this.$parent.$parent.$parent.cargardatos(this.$props.id,"cual","si");
                this.$parent.$parent.$parent.cargarmasdatos(this.$props.id, "cual", "si");
                this.modificado = [];
                this.$emit('ver');
                console.log("pareeeent", this.$parent);
                this.$parent.ver();
                    } else {
                        this.$toast.add({ severity: 'info', summary: 'Cancelado', detail: 'Operación cancelada por el usuario', life: 3000 });
                    }
                }else{
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                }
            }
            
        },
        async comprobarpermisos(){
            const api = new PwgsApi();
            let auxusuario = localStorage.getItem('usuario');
            const resppermisos = await api.get('usuarios/'+auxusuario+'/permisos');
            var permisos = resppermisos.datos;
            for(let permiso of permisos){
                this.permisosusuario.push(permiso.nombre_permiso);
            }
        },
        rellenarcliente() {
            if(confirm("¿Desea añadir este cliente al expediente?  Si modifica sus datos los cambios se aplicarán a todos sus servicios.")){
                this.clienteasegurado = this.clienteseleccionado;
                this.numero_iban1 = this.clienteasegurado.numero_iban1;
                this.numero_iban2 = this.clienteasegurado.numero_iban2;
                this.numero_cuenta = this.clienteasegurado.numero_cuenta;
                this.numero_entidad = this.clienteasegurado.numero_entidad;
                this.numero_oficina = this.clienteasegurado.numero_oficina;
                this.numero_dc = this.clienteasegurado.numero_dc;            
                this.modificado['provincia']=1;
                this.modificado['poblacion']=1;
                this.modificado['nombre']=1;
                this.modificado['razonsocial']=1;
                this.modificado['nif']=1;
                this.modificado['telefono']=1;
                this.modificado['telefono2']=1;
                this.modificado['telefono3']=1;
                this.modificado['telefono']=1;
                this.modificado['telefono2']=1;
                this.modificado['telefono3']=1;
                this.modificado['email']=1;
                this.modificado['direccion']=1;
                this.modificado['cpostal']=1;
                this.modificado['descrtelefono']=1;
                this.modificado['descrtelefono2']=1;
                this.modificado['descrtelefono3']=1;
                this.modificado['iban']=1;
                this.modificado['iban']=1;
                this.modificado['iban']=1;
                this.modificado['iban']=1;
                this.modificado['iban']=1;
                this.modificado['iban']=1;
                this.modificado['observaciones']=1;
                this.modificado['poliza']=1;
                this.modificado['compania']=1;
                this.modificado['vip']=1;
                this.modificado['tipoidentificacion']=1;
                this.$refs.buscadorclientes2.hide();
                //  this.guardarasegurado(); 
            }         
        }
    },
    components: {
        'Dropdown': Dropdown,
    },
    watch: {
        id() { 
            this.auxbuscador = '';
           //this.clienteasegurado = this.$props.asegurado;
            this.idcliente = this.$props.asegurado.idcliente;
            this.cargarasegurado();

        },
        aux() { 
            this.cargarasegurado()
        },
        guardaraseguradotoken() { 
            this.guardarasegurado();

        },
        clienteseleccionado(nuevo) {
           if (nuevo && typeof nuevo === 'object' && nuevo.id) {
             this.rellenarcliente();
            }
            else {
               // this.deshabilitado = false;
                this.cliente = '';
            }
        }/*
        clienteseleccionado() {
            if (this.clienteseleccionado) {
                this.rellenarcliente();
            }
            else {
                this.cliente = '';
            }
        }*/
    },
    
})




</script>
